
import { defineComponent } from '@nuxtjs/composition-api'
//    <span v-if="context.label && context.rules.some((rule) => rule.ruleName === 'required')" class="text-app-primary-1-red--fire-brick"> *</span>

export default defineComponent({
  props: {
    context: { type: Object, required: true },
    labelIsHtml: { type: Boolean, required: false, default: false },
  },
})
